import {
  REFRESHTOKEN_FAIL,
  REFRESHTOKEN_SUCCESS,
  SSO_REFRESH_SUCCESS,
  SSO_REFRESH_FAIL,
} from "../actionTypes";

const initialState = {
  user: null,
};

const refreshTokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFRESHTOKEN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload.user,
      };
    case REFRESHTOKEN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case SSO_REFRESH_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload,
      };
    case SSO_REFRESH_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    default:
      break;
  }

  return state;
};

export default refreshTokenReducer;
